import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { sceneImages } from '../../data/images';
const tiles = [{
  title: 'Pools',
  body: 'Wash walls and floors in color.',
  image: sceneImages.mediumPool,
  span: 'lg:col-span-2 lg:row-span-2'
}, {
  title: 'Spas & hot tubs',
  body: 'Compact, intimate light.',
  image: sceneImages.spa,
  span: ''
}, {
  title: 'Steps & entries',
  body: 'Define edges after dark.',
  image: sceneImages.poolSteps,
  span: ''
}];
export function ApplicationsStrip() {
  return <section aria-labelledby="apps-title" className="bg-deep" data-id="element-195" data-mp="a8af9r2njul9">
      <div className="mx-auto max-w-site px-5 py-24 md:px-8 md:py-32" data-id="element-196" data-mp="3rg5rxs00s06s">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-197" data-mp="8jh9fevuxgf">
          <h2 id="apps-title" className="font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-198" data-mp="1pnpy30kahzxg">
            Transform Your Water
            <span className="block text-ice" data-id="element-199" data-mp="1ulj4nupi8vy9">After Dark.</span>
          </h2>
          <Link to="/applications" className="inline-flex items-center gap-2 font-display text-base font-semibold uppercase tracking-[0.12em] text-white hover:text-ice" data-id="element-200" data-mp="2wi1jkugtg4lr">
            All applications <ArrowRightIcon className="h-4 w-4" data-id="element-201" data-mp="367bd8erb5vbz" />
          </Link>
        </div>
        <div className="mt-12 grid gap-4 lg:grid-cols-3 lg:grid-rows-2" data-id="element-202" data-mp="3199u5ttvtw0i">
          {tiles.map(tile => <figure key={tile.title} className={`relative min-h-[280px] overflow-hidden rounded-2xl ${tile.span}`} data-id="element-203" data-mp="2dl0aaxg8bic0">
              <img src={tile.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-204" data-mp="28mfagz4w30o3" />
              <div className="absolute inset-x-0 bottom-0 bg-[#030A14]/70 p-5 backdrop-blur-sm" data-id="element-205" data-mp="2mm6ubgi37ba0">
                <figcaption data-id="element-206" data-mp="2ihh15zetcass">
                  <span className="block font-display text-2xl font-semibold uppercase" data-id="element-207" data-mp="2ilekal1e52co">{tile.title}</span>
                  <span className="text-sm text-titanium" data-id="element-208" data-mp="3ty7cfwy3fst9">{tile.body}</span>
                </figcaption>
              </div>
            </figure>)}
        </div>
      </div>
    </section>;
}